import { ApolloClient } from '@apollo/client';
import { envVars } from '@/config';
import { isSSR } from '@/utils';
import { cache } from './cache';
import { link } from './link';

export const client = new ApolloClient({
  clientAwareness: {
    name: 'quesmed-admin',
    version: '1.0.172',
  },
  cache,
  link,
  devtools: {
    enabled: envVars.env === 'development',
    name: 'quesmed-admin-devtools',
  },
  // connectToDevTools: envVars.env === 'development',
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-first',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'cache-first',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
  ssrMode: isSSR,
});
